import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { Flex } from 'rebass';

import { postExternalMedium } from 'story-media/api';
import { useEntityActionCreators } from 'entities/hooks/index';
import { usePostNewMeeting } from 'chats/hooks';
import { ButtonBar, Button } from './styled';
import { createMediaForFiles, createTextMedium } from '../../story-media/actions';
import { useHistory, useToggle } from '../../app/hooks';
// import LinkButton from '../link/link-button';
import NewMediaPopup from '../../story-media/new';
import { FaPlus } from "react-icons/fa6";
import useLocation from 'app/hooks/location';
import { useFFmpeg } from 'contexts/FFmpegContext';

const ButtonBarWrap = ({ storyId, onSuccess, ...props }) => {
  const { pathname } = useLocation();
  const [on, toggle] = useToggle();
  const { replace } = useHistory();
  const dispatch = useDispatch();
  const { position } = props;
  const { receive } = useEntityActionCreators();
  const postNewMeeting = usePostNewMeeting(storyId, position);
  const { ffmpeg } = useFFmpeg();

  const submitText = useCallback(values => dispatch(createTextMedium(storyId, values)), [
    dispatch,
    storyId,
  ]);
  const submitMedia = useCallback(
    (files, transcribe) => dispatch(createMediaForFiles(storyId, files, position, false, transcribe, null, ffmpeg)),
    [dispatch, position, storyId, ffmpeg]
  );

  useEffect(() => {
    if (window.location.search.includes('add-to-story')) {
      toggle();
      replace(`/story/${storyId}/edit`);
    }
  }, [])
  const navigate = () => {
    if (pathname.includes('/tell_a_story/')) {
      if (pathname.includes('/tell_a_story/new'))
        replace(`/tell_a_story/new/${storyId}`);
      else
        replace(`/tell_a_story/story/${storyId}/edit`);
    }
    else if (!pathname.includes('new')) {
      replace(`/story/${storyId}/edit`);
    }
  }

  return (
    <ButtonBar>
      <Button onClick={toggle}>
        <Flex justifyContent="center" alignItems="center">
          <FaPlus size="20px" />
        </Flex>
      </Button>
      {on && (
        <NewMediaPopup
          title="Add to Story"
          position={position}
          onRecordChat={async () => {
            const [payload] = await postNewMeeting();
            replace(`/story/${storyId}/chats/${payload.data.result.meetings[0]}`);
          }}
          onSubmitExternalMedium={({ externalURL }) => {
            postExternalMedium({ externalURL, storyId, position })
              .then(payload => receive({ payload }))
              .then(() => {
                navigate()
                if (onSuccess)
                  onSuccess();
                toggle();
              });
          }}
          onSubmitText={({ text }) => {
            submitText({ text, 'page-position': position }).then(() => {
              navigate()
              if (onSuccess)
                onSuccess();
              toggle();
            });
          }}
          onSubmitMedia={(files, transcribe = false) => {
            submitMedia(files, transcribe).then(() => {
              navigate()
              if (onSuccess)
                onSuccess();
              toggle();
            });
          }}
          onClose={toggle}
        />
      )}
      {/* <LinkButton {...props} /> */}
    </ButtonBar>
  );
};

ButtonBarWrap.propTypes = {
  storyId: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  pageIdBefore: PropTypes.string,
  pageIdAfter: PropTypes.string,
  isLastPage: PropTypes.bool,
  onSuccess: PropTypes.func.isRequired,
};

ButtonBarWrap.defaultProps = {
  pageIdBefore: '',
  pageIdAfter: '',
  isLastPage: false,
};

export default ButtonBarWrap;
